import React, { useId } from 'react';
import { RING_STOPS } from '../wall/wallTokens';

/**
 * The view-limit mark: a number inside a portal ring.
 *
 * Instagram's is a dashed circle with the count in it; ours is the same idea drawn with the
 * portal's own colours — the seven party stops around a dashed ring, the number in the mono
 * face. `n` is 1 (view once) or 2 (view twice); `check` draws a tick instead, for "unlimited"
 * and for an opened capsule; `on` fills the disc black with a white figure, which is how the
 * composer says the setting is live.
 */
export default function ViewLimitIcon({ n = 1, size = 28, on = false, check = false, muted = false, style, ...rest }) {
  const id = useId();
  const gradId = `vl-ring-${id}`;
  const r = 11;
  const c = 14;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      aria-hidden
      data-view-limit={check ? 'check' : n}
      style={{ display: 'block', flexShrink: 0, opacity: muted ? 0.45 : 1, ...style }}
      {...rest}
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
          {RING_STOPS.map((stop, i) => <stop key={stop} offset={`${(i / (RING_STOPS.length - 1)) * 100}%`} stopColor={stop} />)}
        </linearGradient>
      </defs>
      {on && <circle cx={c} cy={c} r={r} fill="#000" />}
      <circle cx={c} cy={c} r={r} fill="none" stroke={muted ? 'currentColor' : `url(#${gradId})`} strokeWidth="2.2" strokeDasharray="4.1 2.4" strokeLinecap="round" transform={`rotate(-90 ${c} ${c})`} />
      {check ? (
        <path d="M9 14.5l3.2 3.2L19.5 10.5" fill="none" stroke={on ? '#fff' : 'currentColor'} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      ) : (
        <text x={c} y={c + 0.5} textAnchor="middle" dominantBaseline="central" fontFamily="'JetBrains Mono', ui-monospace, monospace" fontWeight="700" fontSize="12.5" fill={on ? '#fff' : 'currentColor'}>{n}</text>
      )}
    </svg>
  );
}
